export const environment = {
  production: true,
  buildId: '2726658599718611',
  configFile: 'config.json',
};
